import { ChiroUpAPI } from '@chiroup/client-core/functions/ChiroUpAPI';
import {
  LegalDocumentAcceptance,
  LegalDocumentDownload,
  LegalDocumentDraftInput,
  LegalDocumentPublishInput,
  LegalDocumentVersion,
} from '@chiroup/core/types/LegalDocument.type';

export const legalDocumentService = {
  catalog: (): Promise<LegalDocumentVersion[]> => ChiroUpAPI.get('api', '/documents', {}),
  create: (body: LegalDocumentDraftInput): Promise<{ id: string }> =>
    ChiroUpAPI.post('api', '/documents', { body }),
  publish: (id: string, body: LegalDocumentPublishInput): Promise<{ success: boolean }> =>
    ChiroUpAPI.post('api', `/documents/${id}/publish`, { body }),
  download: (
    versionId: string,
    clinicId?: number,
    acceptanceId?: string
  ): Promise<LegalDocumentDownload> =>
    ChiroUpAPI.get(
      'api',
      clinicId
        ? `/clinics/${clinicId}/documents/${versionId}/download`
        : `/documents/${versionId}/download`,
      { queryParams: { acceptanceId } }
    ),
  history: (clinicId: number): Promise<LegalDocumentAcceptance[]> =>
    ChiroUpAPI.get('api', `/clinics/${clinicId}/documents`, {}),
};
